<script lang="ts">
  import { onMount } from "svelte";
  import { navigate } from "../../app.logic";
  import Input from "../../components/Form/Fields/Input.svelte";
  import FormField from "../../components/Form/FormField.svelte";
  import FormLayout from "../../layout/FormLayout.svelte";
  import type { IApiResponse } from "../../utils/api/api-response";
  import { initDetail, record, save, stats } from "./customer.store";
  import Textarea from "../../components/Form/Fields/Textarea.svelte";
  import type { ICustomer } from "../../entities/customer";
  import Switch from "../../components/Form/Fields/Switch.svelte";
  import NumberInput from "../../components/Form/Fields/NumberInput.svelte";
  import ClfDropdown from "../../components/Form/Fields/Dropdown/ClfDropdown.svelte";

  export let oid: number;

  $: isNew = oid == 0;
  $: canSubmit = $record != null && $record.name != "";

  async function onSubmit() {
    let newP = isNew;
    let _resp: IApiResponse<ICustomer> = await save();
    let u = _resp.payload;
    if (newP) {
      oid = u.oid;
      record.set(u);
      navigate(`/customer/${u.oid}`);
    } else {
      onCancel();
    }
  }

  function onCancel() {
    navigate(`/customer`);
  }

  onMount(() => initDetail(oid));
</script>

{#if $record}
  <div class="columns">
    <div class="column is-12">
      <FormLayout {canSubmit} {isNew} on:submit={onSubmit} on:cancel={onCancel}>
        <div class="columns">
          <div class="column is-6">
            <FormField>
              <Input name="Denominazione" placeholder="denominazione" required={true} bind:value={$record.name} />
            </FormField>
          </div>
          <div class="column is-2">
            <FormField>
              <Switch name="Cliente" bind:value={$record.customerFlag} />
            </FormField>
          </div>
          <div class="column is-2">
            <FormField>
              <Switch name="Fornitore" bind:value={$record.supplierFlag} />
            </FormField>
          </div>
          <div class="column is-2">
            <FormField>
              <Switch name="Vettore" bind:value={$record.carrierFlag} />
            </FormField>
          </div>
          <!--
            <div class="column is-1"></div>
            <div class="column is-1">
              <FormField>
                <Switch name="Cancellato" bind:value={$record.deleted} />
              </FormField>
            </div>
            -->
        </div>
        <div class="columns">
          <div class="column is-6">
            <FormField>
              <Input name="Indirizzo principale" placeholder="indirizzo" required={false} disabled={true} bind:value={$record.street} />
            </FormField>
          </div>
          <div class="column is-1">
            <FormField>
              <Input name="Civico" placeholder="civico" required={false} disabled={true} bind:value={$record.civicNumber} />
            </FormField>
          </div>
          <div class="column is-3">
            <FormField>
              <Input name="Comune" placeholder="comune" required={false} disabled={true} bind:value={$record.city} />
            </FormField>
          </div>
          <div class="column is-1">
            <FormField>
              <Input name="Provincia" placeholder="provincia" maxlength={2} required={false} disabled={true} bind:value={$record.province} />
            </FormField>
          </div>
          <div class="column is-1">
            <FormField>
              <Input name="CAP" placeholder="CAP" required={false} disabled={true} bind:value={$record.zipCode} />
            </FormField>
          </div>
        </div>

        <div class="columns">
          <div class="column is-6">
            <FormField>
              <Input name="Codice Fiscale" placeholder="codice fiscale" required={false} bind:value={$record.fiscalCode} />
            </FormField>
          </div>
          <div class="column is-6">
            <FormField>
              <Input name="Partita IVA" placeholder="partita iva" required={false} bind:value={$record.vatNumber} />
            </FormField>
          </div>
        </div>

        <div class="columns">
          <div class="column is-3">
            <FormField>
              <Input name="Telefono 1" placeholder="" required={false} bind:value={$record.phone1} />
            </FormField>
          </div>
          <div class="column is-3">
            <FormField>
              <Input name="Telefono 2" placeholder="" required={false} bind:value={$record.phone2} />
            </FormField>
          </div>
          <div class="column is-3">
            <FormField>
              <Input name="Cellulare 1" placeholder="" required={false} bind:value={$record.mobile1} />
            </FormField>
          </div>
          <div class="column is-3">
            <FormField>
              <Input name="Cellulare 2" placeholder="" required={false} bind:value={$record.mobile2} />
            </FormField>
          </div>
        </div>
        <div class="columns">
          <div class="column is-3">
            <FormField>
              <Input name="E-mail" placeholder="" required={false} bind:value={$record.email} />
            </FormField>
          </div>
          <div class="column is-3">
            <FormField>
              <Input name="PEC" placeholder="" required={false} bind:value={$record.emailPec} />
            </FormField>
          </div>
          <div class="column is-6">
            <FormField>
              <Input name="Sito web" placeholder="" required={false} bind:value={$record.website} />
            </FormField>
          </div>
        </div>

        <h2 class="subtitle">Accordi Commerciali</h2>

        <div class="columns">
          <div class="column is-6">
            <FormField>
              <NumberInput name="Calo Peso Fisso [Kg]" placeholder="" required={false} bind:value={$record.fixedWeightLoss} />
            </FormField>
          </div>
          <div class="column is-6">
            <FormField>
              <NumberInput name="Calo Peso [%]" placeholder="" required={false} bind:value={$record.percWeightLoss} />
            </FormField>
          </div>
        </div>

        <div class="columns">
          <div class="column is-6">
            <FormField>
              <ClfDropdown
                name="Tipo Pagamento"
                placeholder=""
                schema="PAYMENTTYP"
                required={false}
                clearVisible={true}
                bind:value={$record.clfPaymentTypeId}
              />
            </FormField>
          </div>
          <div class="column is-2">
            <FormField>
              <Switch name="Trasporto a caldo" bind:value={$record.hotTransportExecuted} />
            </FormField>
          </div>
          <div class="column is-2">
            <FormField>
              <Switch name="Trasporto con mezzo refrigerato" bind:value={$record.hotTransportCooled} />
            </FormField>
          </div>
          <div class="column is-2">
            <FormField>
              <Switch name="TRC" bind:value={$record.trc} />
            </FormField>
          </div>
        </div>

        <div class="columns">
          <div class="column is-12">
            <FormField>
              <Textarea name="Note" placeholder="note" required={false} bind:value={$record.notes} />
            </FormField>
          </div>
        </div>
      </FormLayout>
    </div>
  </div>
{/if}
